import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { Box, Tab, Typography } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import ImportConnectorPage from "./ImportConnectorPage.jsx";
import ImportSourceConfigPage from "./ImportSourceConfigPage.jsx";
import ImportMappingProfilePage from "./ImportMappingProfilePage.jsx";
import ImportJobsTab from "./ImportJobsTab.jsx";
import ImportCustomerSettingsTab from "./ImportCustomerSettingsTab.jsx";

const TABS = [
  { value: "jobs", label: "Jobs & Tasks", path: "/admin/imports/jobs" },
  {
    value: "connectors",
    label: "Connectoren",
    path: "/admin/imports/connectors",
  },
  { value: "sources", label: "Quellen", path: "/admin/imports/sources" },
  { value: "mappings", label: "Mappings", path: "/admin/imports/mappings" },
  {
    value: "customer-settings",
    label: "Kunden-Einstellungen",
    path: "/admin/imports/customer-settings",
  },
];

export default function ImportSettingsPage() {
  const { setBreadcrumbs } = useBreadcrumb();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Einstellungen", path: "/admin/settings" },
      { name: "Import", path: "/admin/imports" },
    ]);
  }, [setBreadcrumbs]);

  const activeTab =
    TABS.find((t) => location.pathname.startsWith(t.path))?.value ?? "jobs";

  return (
    <>
      <Typography variant="h5" mb={2}>
        Import
      </Typography>

      <TabContext value={activeTab}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={(_, v) => navigate(TABS.find((t) => t.value === v).path)}
          >
            {TABS.map((t) => (
              <Tab key={t.value} label={t.label} value={t.value} />
            ))}
          </TabList>
        </Box>

        <TabPanel value="jobs" sx={{ px: 0 }}>
          <ImportJobsTab />
        </TabPanel>
        <TabPanel value="connectors" sx={{ px: 0 }}>
          <ImportConnectorPage />
        </TabPanel>
        <TabPanel value="sources" sx={{ px: 0 }}>
          <ImportSourceConfigPage />
        </TabPanel>
        <TabPanel value="mappings" sx={{ px: 0 }}>
          <ImportMappingProfilePage />
        </TabPanel>
        <TabPanel value="customer-settings" sx={{ px: 0 }}>
          <ImportCustomerSettingsTab />
        </TabPanel>
      </TabContext>
    </>
  );
}
